// src/app/pages/selection/selection.component.ts
import { Component, OnInit, Input } from '@angular/core';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AuthService } from 'src/app/services/auth.service';
import { Config } from '../../models/config.model';

@Component({
  selector: 'app-selection',
  templateUrl: './selection.component.html',
  styleUrls: ['./selection.component.scss']
})
export class SelectionComponent implements OnInit {
  config: Config | null;
  constructor(
    private sharedDataService: SharedDataService,
    private navigationService: NavigationService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.sharedDataService.getConfig().subscribe(config => this.config = config);
    window.scrollTo(0, 0);
  }

  onPlanClick(plan: any): void {
    this.sharedDataService.setPlan(plan);
    this.navigationService.navigateForward();
  }
}
